const L_SITE_URL = "http://localhost:3001";
const P_SITE_URL = "https://invest19.com";
export const L_API_URL = "https://gatewayapi.invest19.com";
export const P_API_URL = "https://gatewayapi.invest19.com";
export const SITE_URL = process.env.NODE_ENV === "production" ? P_SITE_URL : L_SITE_URL;
export const API_URL = process.env.NODE_ENV === "production" ? P_API_URL : L_API_URL;
export const JWTToken = "_trinkerr_";
